import React, { useEffect, useMemo, useState } from 'react'
import { COLUMNS } from './featureColumn'
import { Button,  Table } from 'reactstrap';
import { BiEditAlt } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';

export const CommunityFeatPaginationTable = ({data}) => {
  const columns = useMemo(() => COLUMNS, [])
  const navigate = useNavigate();
  const pageSize = 5;
  const [pageIndex, setPageIndex] = useState(0);

  const pageCount = Math.max(1, Math.ceil((data?.length || 0) / pageSize));

  useEffect(() => {
    if (pageIndex > pageCount - 1) {
      setPageIndex(Math.max(0, pageCount - 1));
    }
  }, [pageCount, pageIndex]);

  const page = useMemo(() => {
    const start = pageIndex * pageSize;
    return (data || []).slice(start, start + pageSize);
  }, [data, pageIndex]);

  const canPreviousPage = pageIndex > 0;
  const canNextPage = pageIndex < pageCount - 1;
  const gotoPage = (index) => {
    const safeIndex = Math.min(Math.max(index, 0), pageCount - 1);
    setPageIndex(safeIndex);
  };
  const previousPage = () => gotoPage(pageIndex - 1);
  const nextPage = () => gotoPage(pageIndex + 1);

  return (
    <>
      <Table responsive hover>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.accessor}>{column.Header}</th>
            ))}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {page.map((row, i) => {
            return (
              <tr key={row.id || i}>
                {columns.map((column) => (
                  <td key={column.accessor}>{row[column.accessor]}</td>
                ))}
                <td>
                <BiEditAlt className="edit_icon icon_hover" onClick={() => navigate(`/community/feature/edit/${row.id}`)} size={20}/>
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
      <div className="text-center">
        <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </Button>{' '}
        <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
          Previous
        </Button>{' '}
        <Button onClick={() => nextPage()} disabled={!canNextPage}>
          Next
        </Button>{' '}
        <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </Button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageCount}
          </strong>{' '}
        </span>
        <span>
          | Go to page:{' '}
          <input
            type='number'
            value={pageIndex + 1}
            onChange={e => {
              const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(pageNumber)
            }}
            style={{ width: '50px' }}
          />
        </span>{' '}
        <select value={pageSize} readOnly>
          {[5].map(size => (
            <option key={size} value={size}>
              Show {size}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}